import { QuestionStyleTypes } from '../../../form-runtime-context/contracts';
import { useQuestionStyle } from '../../../form-runtime-context/form-runtime-context';

export function useMuiInputQuestionStyle(id: string) {
	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);
	const sx = {
		'.MuiInputBase-root': {
			color,
			fontSize,
			fontStyle,
			fontFamily,
			textDecoration,
			fontWeight
		},
		'input:focus, textarea': {
			border: '0',
			boxShadow: 'none'
		}
	};
	return sx;
}
